import { Create, Datagrid, Edit, EditButton, List, Loading, SimpleForm, TextField, TextInput, useCreate, useGetList } from "react-admin";


export const OrderTesterList = () => (
    <List sort={{ field: "id", order: "DESC" }}>
        <Datagrid bulkActionButtons={false}>
            <TextField source="name" label="Description"/>
            <TextField source="emailRegexRule" label="Regex rule"/>
            <EditButton />
        </Datagrid>
    </List>
)

export const OrderTesterEdit = () => {
  return (
    <Edit mutationMode="pessimistic">
        <SimpleForm>
            <TextInput source="name" label="Description"/>
            <TextInput source="emailRegexRule" label="Regex"/>
        </SimpleForm>
    </Edit>
  );
};


export const OrderTesterCreate = () => {
    return (
        <Create>
            <SimpleForm>
                <TextInput source="name" label="Description"/>
                <TextInput source="emailRegexRule" label="Regex"/>
            </SimpleForm>
        </Create>
    );
};